import { render } from "./RegisterInterestView.vue?vue&type=template&id=5dae959c&scoped=true"
import script from "./RegisterInterestView.vue?vue&type=script&lang=js"
export * from "./RegisterInterestView.vue?vue&type=script&lang=js"

import "./RegisterInterestView.vue?vue&type=style&index=0&id=5dae959c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dae959c"]])

export default __exports__